import { Box, Typography, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import SearchOffOutlinedIcon from "@mui/icons-material/SearchOffOutlined";

const PlansEmptyState = ({ isSearch, onNewPlan }) => {
  const Icon = isSearch ? SearchOffOutlinedIcon : AssignmentOutlinedIcon;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        py: 10,
        color: "text.secondary",
      }}
    >
      <Box
        sx={{
          width: 64,
          height: 64,
          borderRadius: "16px",
          background: "linear-gradient(135deg, rgba(255,82,0,0.1), rgba(255,140,0,0.06))",
          border: "1px solid rgba(255,82,0,0.18)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mb: 2.5,
        }}
      >
        <Icon sx={{ color: "#FF5200", fontSize: 30 }} />
      </Box>
      <Typography variant="h6" sx={{ fontWeight: 700, color: "#111827", mb: 0.5 }}>
        {isSearch ? "No plans match your search" : "No plans yet"}
      </Typography>
      <Typography sx={{ mb: 3, color: "#9CA3AF" }}>
        {isSearch
          ? "Try a different name or clear your search."
          : "Create a plan to start organizing influencers for a campaign."}
      </Typography>
      {!isSearch && (
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={onNewPlan}
          sx={{
            background: "linear-gradient(135deg, #FF5200 0%, #FF8C00 100%)",
            boxShadow: "0 4px 14px rgba(255,82,0,0.3)",
            "&:hover": {
              background: "linear-gradient(135deg, #FF5200 0%, #FF8C00 100%)",
              opacity: 0.9,
              boxShadow: "0 6px 20px rgba(255,82,0,0.45)",
            },
            borderRadius: "10px",
            textTransform: "none",
            fontWeight: 700,
            px: 3,
          }}
        >
          New Plan
        </Button>
      )}
    </Box>
  );
};

export default PlansEmptyState;
